import { Component, OnInit } from '@angular/core';
import { AppserviceService } from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as myGlobals from 'src/app/globals';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.sass']
})
export class UserComponent implements OnInit {
  userDetails = {
    'longname':'',
    'shortname':'',
    'email':''
  };
  userName;
  userfound:boolean = false;
  usersdatapath = '../../assets/json/users.json';
  count:number = 0;
  loadDataBtn:boolean = false;
  userinsertbol:boolean = false;
  loadData = [];
  recordsUpload = '';
  usermessage = '';
  userRespclass = '';

  constructor(private appService:AppserviceService, private spinner:NgxSpinnerService) { }

  getuser(user){
    if(user != '' && user != undefined){
      this.userinsertbol = false;
      this.spinner.show();
      this.appService.searchUser(user).subscribe(
        (data) => {
          this.spinner.hide();
          console.log(data);
          if(data['data'].length > 0){
            this.userfound = true;
            this.userDetails['longname'] = data['data'][0]['LONGNAME'];
            this.userDetails['shortname'] = data['data'][0]['SHORTNAME'];
            this.userDetails['email'] = data['data'][0]['EMAIL'];
            this.userinsertbol = true;
            this.usermessage = 'User found!';
            this.userRespclass = myGlobals.appMessages['classes']['success'];
          }else{
            this.userfound = false;
            this.userinsertbol = true;
            this.usermessage = 'User not found!';
            this.userRespclass = myGlobals.appMessages['classes']['error'];
          } 
        },
        (err) => {
          this.spinner.hide();
          console.log(err);
          this.userfound = false;
          this.userinsertbol = true;
          this.usermessage = err['message'];
      });
    }else{
      this.userinsertbol = true;
      this.usermessage = 'Please enter the User Details!';
      this.userRespclass = myGlobals.appMessages['classes']['warning'];
    }
    
  }

  loadUsersData(){
    this.spinner.show();
    this.appService.getUsersData(this.usersdatapath).subscribe(
      (usersdata) => {
        this.spinner.hide();
        console.log(usersdata['ibm-users']);
        this.recordsUpload = usersdata['records'];
        if(usersdata['records'] === 'new'){
          this.loadDataBtn = true;
          this.loadData = usersdata['ibm-users'];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  performDataLoad(){
    //var this = this;
    //var insertUserRecord = setInterval(function(){
    if(this.count != this.loadData.length){
      this.userDetails['shortname'] = this.loadData[this.count]['employee'];
      this.userDetails['longname'] = this.loadData[this.count]['name'];
      this.userDetails['email'] = this.loadData[this.count]['email'];
      this.insertUser();
    }else{
      this.loadDataBtn = false;
    }
  }

  insertUser(){
    console.log(this.userDetails);
    this.spinner.show();
    this.appService.insertUser(this.userDetails).subscribe(
      (data) => {
        this.spinner.hide();
        console.log(data);
        if(data['success']){
          this.userfound = true;
          console.log('Record inserted');
          if(this.recordsUpload === 'new'){
            this.performDataLoad();
            this.count = this.count + 1;
            this.usermessage = this.count + ' ' + data['success'];
          }else{
            this.usermessage = data['success'];
            this.resetUser();
          }
          this.userinsertbol = true;
          this.userRespclass = myGlobals.appMessages['classes']['success'];
        }else{
          this.userfound = false;
        }
      },
      (err) => {
        console.log(err);
        this.spinner.hide();
    });
  }
  resetUser(){
    this.userDetails = {
      'longname':'',
      'shortname':'',
      'email':''
    };
    this.userName = '';
    this.userfound = false;
    this.userinsertbol = false;
  }

  ngOnInit() {
    //this.loadUsersData();
  }

}
